export default {
  id: 0,
  name: '',
  active: '',
  created_at: '',
  updated_at: ''
}
